import React from 'react'

import { ZariContext } from '_zari/context'

import { Alert, Modal, Table, Button } from '_zari/core'

import * as AsientoContableService from 'services/asientosContables.service'

const DetallesTcDiferentesModal = ({ show, handleClose, mes }) => {
  const __zariContext = React.useContext(ZariContext)

  const [detallesTcDiferente, setDetallesTcDiferente] = React.useState([])
  const [buscando, setBuscando] = React.useState(true)

  React.useEffect(() => {
    AsientoContableService.obtenerDetallesTcDiferentexMes(mes)
      .then(({ data }) => {
        if (data) {
          setDetallesTcDiferente(data)
        }
      })
      .catch(({data: {error}}) => {
        __zariContext.snack('error', error)
        setDetallesTcDiferente([])
      })
      .finally(() => {
        setBuscando(false)
      })
  }, [mes, __zariContext])

  const clickCorregirTiposCambio = React.useCallback(() => {
    __zariContext.loader.open('Recalculando montos de compras y ventas segun tipo de cambio ...')

    const idsDetalles = detallesTcDiferente.map(x => x._id)

    AsientoContableService.recalcularTcComprasVentas(idsDetalles)
      .then(() => {
        __zariContext.snack('success', 'Montos actualizados satisfactoriamente.')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, detallesTcDiferente])

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>CORRECCION TIPOS CAMBIO</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {buscando ? (
          <Alert color='info'>Obteniendo diferencias en asientos.</Alert>
        ) : (
          <>
            {/* {detallesTcDiferente.length === 0 ? (
              <Alert color='warning'>No se ha encontrado asientos con diferencias.</Alert>
            ) : ( */}
            <Table
              filas={detallesTcDiferente}
              headRows={[
                {
                  label: 'ORIGEN'
                },
                {
                  label: 'NUM OPE'
                },
                {
                  label: 'FECHA'
                },
                {
                  label: 'TC CALCULADO'
                },
                {
                  label: 'TC BASE'
                }
              ]}
              maxRowsShown={15}
              rowTemplate={row => (
                <Table.Row key={row._id}>
                  <Table.Cell>{row.origen || '--'}</Table.Cell>
                  <Table.Cell>{row.numeroOperacion || '--'}</Table.Cell>
                  <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
                  <Table.Cell>{row.tipoCambioDetalle || '--'}</Table.Cell>
                  <Table.Cell>{row.tipoCambioRegular || '--'}</Table.Cell>
                </Table.Row>
              )}
            />
            {/* )} */}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose} color='secondary' outline>
          Cancelar
        </Button>
        <Button onClick={clickCorregirTiposCambio}>Corregir tipos cambio</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DetallesTcDiferentesModal
